var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72246 7.41021C5.89051 7.52236 6.10954 7.52236 6.27759 7.41021L11.2723 4.07668C11.6837 3.80213 11.4893 3.1608 10.9947 3.1608H8.80837V1C8.80837 0.723857 8.58451 0.5 8.30837 0.5L3.93762 0.5C3.66148 0.5 3.43762 0.723857 3.43762 1V3.1608H1.00531C0.510738 3.1608 0.316379 3.80213 0.727745 4.07668L5.72246 7.41021Z",
    fill: "#F44336"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.78ec80cbf591cd38bef50e57d6f167b1.svg";
export { ForwardRef as ReactComponent };